import { render, staticRenderFns } from "./playersDetail.vue?vue&type=template&id=ff6e8afc&scoped=true"
import script from "./playersDetail.vue?vue&type=script&lang=js"
export * from "./playersDetail.vue?vue&type=script&lang=js"
import style0 from "./playersDetail.vue?vue&type=style&index=0&id=ff6e8afc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6e8afc",
  null
  
)

export default component.exports